import { render, staticRenderFns } from "./cardIntegralList.vue?vue&type=template&id=9edb6c90&scoped=true&"
import script from "./cardIntegralList.vue?vue&type=script&lang=js&"
export * from "./cardIntegralList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edb6c90",
  null
  
)

export default component.exports